import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import {
  IOsAppFeature,
  NotIOsAppFeature,
} from '@sorare/core/src/components/BuyableFeature';

import { AuctionReminder } from '#src/components/auction/AuctionReminder/index.tsx';
import { BidField } from '#src/components/buyActions/BidField/index.tsx';

import type { AuctionsActions_auction } from './__generated__/index.graphql.ts';

type Props = { auction: AuctionsActions_auction };

export const AuctionsActions = ({ auction }: Props) => {
  return (
    <>
      <NotIOsAppFeature exceptMarketAuthorizedIosApp>
        <Horizontal>
          <AuctionReminder color="quaternary" auction={auction} small />
          <BidField color="quaternary" variant="small" auction={auction} />
        </Horizontal>
      </NotIOsAppFeature>
      <IOsAppFeature exceptMarketAuthorizedIosApp>
        <AuctionReminder color="quaternary" auction={auction} withText small />
      </IOsAppFeature>
    </>
  );
};

AuctionsActions.fragments = {
  auction: gql`
    fragment AuctionsActions_auction on TokenAuction {
      id
      ...BidField_auction
      ...AuctionReminder_auction
    }
    ${BidField.fragments.auction}
    ${AuctionReminder.fragments.auction}
  ` as TypedDocumentNode<AuctionsActions_auction>,
};
